import AvatarEditorModal from './AvatarEditorModal';

export default AvatarEditorModal;
